const originalFavicon = favicon => {
  if (!favicon.dataset.originalHref) {
    favicon.dataset.originalHref = favicon.href;
  }
  return favicon.dataset.originalHref;
};

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // Keep the installation favicon instead of replacing it with a stock asset.
    favicon.href = originalFavicon(favicon);
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(originalFavicon);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href = originalFavicon(favicon);
      });
    }
  });
};
